import { ColumnItemElement, DreamBlock } from '@typedream/core';
import {
  getNodeParent,
  isElementEmpty,
  liftNodes,
  removeNodes,
  TNodeEntry,
  unwrapNodes,
  withoutNormalizing,
} from '@udecode/plate-core';
import { DreamEditor } from '../../../types';

export const normalizeColumnItem = (
  editor: DreamEditor,
  entry: TNodeEntry<ColumnItemElement>,
) => {
  const [node, path] = entry;

  // remove empty column item
  if (isElementEmpty(editor, node)) {
    removeNodes(editor, { at: path });
    return true;
  }

  // lift node if it's the only item in column
  try {
    const parent = getNodeParent<DreamBlock>(editor, path);
    if (parent.type === 'column' && parent.children.length === 1) {
      withoutNormalizing(editor, () => {
        liftNodes(editor, { at: path });
      });
      return true;
    }
  } catch (error) {
    /*  */
  }

  // unwrap node if the parent is not a column
  try {
    const parent = getNodeParent<DreamBlock>(editor, path);
    if (parent.type !== 'column') {
      unwrapNodes(editor, { at: path });
      return true;
    }
  } catch (error) {
    /*  */
  }

  return undefined;
};
